import apiRoutes from "../../utils/constants/apiRoutes";
import ApiService from "../apiService";
import handleApiCall from "../handleApi";

export const getAlertService = async () =>
  handleApiCall(() => ApiService.get(apiRoutes.alert));
